
document.addEventListener("DOMContentLoaded", function () {
  // Locate the product JSON in the DOM
  const productJsonScript = document.querySelector('script[type="application/json"][id^="ProductJson-"]');
  if (!productJsonScript) return;

  const productData = JSON.parse(productJsonScript.textContent);
  const variantOptions = productData.options; // e.g., ["Size", "Color"]
  const variants = productData.variants; // list of variant objects

  // Loop through each option (Size, Color, etc.)
  variantOptions.forEach((optionName, optionIndex) => {
    const radios = document.querySelectorAll(
      `[data-option-index="${optionIndex}"] input[type="radio"]`
    );

    radios.forEach((radio) => {
      const value = radio.value;

      // Check if any available variant matches this option value at this index
      const matchingVariant = variants.find((variant) => {
        return (
          variant.options[optionIndex] === value &&
          variant.available
        );
      });

      if (!matchingVariant) {
        // Hide the radio button and its label
        const label = radio.closest("label") || radio.parentElement;
        if (label) label.style.display = "none";
      }
    });
  });
});

